var _defs, _g, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPenSize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-pensize{fill:none;stroke:#707070;stroke-width:2px;}.b-pensize{fill:#6e6e6e;}.c-pensize{stroke:none;}.d-pensize{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a-pensize"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c-pensize",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d-pensize",
    cx: 12.5,
    cy: 12.5,
    r: 11.5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b-pensize",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(9 9)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenSize);
export default __webpack_public_path__ + "static/media/pen-size.7e6dcdf6792039da076003d1f96a0ead.svg";
export { ForwardRef as ReactComponent };